<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-3">
<h1 class="title">T<span class="small">RACING</span> Y<span class="small">OUR</span> F<span class="small">AMILY</span> H<span class="small">ISTORY</span> T<span class="small">HROUGH</span> <span class="small">THE</span> C<span class="small">ENSUS</span></h1>
<p class="title2"><em class="italic">A Guide for Family Historians</em></p>
<p class="autt"><span class="bold">EMMA JOLLY</span></p>
<div class="img_containerp">
<img alt="image" src="images/logo.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?783547ae